import React from 'react';
import { Typography, Box } from '@mui/material';

const Detail = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <Typography variant="body2">
      {label}
    </Typography>
    <Typography variant="subtitle2">
      {value}
    </Typography>
  </Box>
);

export default Detail;
